interface LastReconciliationProps {
  completedAt: number | undefined;
  now: number;
}

export function LastReconciliation({
  completedAt,
  now,
}: LastReconciliationProps) {
  if (!completedAt) return null;

  const minutes = Math.max(0, Math.floor((now - completedAt) / 60_000));
  const elapsed =
    minutes === 0
      ? "hace un momento"
      : minutes < 60
        ? `hace ${minutes} min`
        : `hace ${Math.floor(minutes / 60)} h`;

  return (
    <span className="mt-0.5 block text-xs font-normal italic text-radar-white/70">
      {"Última conciliación: "}
      <time
        dateTime={new Date(completedAt).toISOString()}
        title={new Date(completedAt).toLocaleString("es")}
      >
        {elapsed}
      </time>
    </span>
  );
}
